export var SqlEngineStatus;
(function (SqlEngineStatus) {
    SqlEngineStatus["SQL_ENGINE_STATUS_CREATING"] = "CREATING";
    SqlEngineStatus["SQL_ENGINE_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    SqlEngineStatus["SQL_ENGINE_STATUS_STOPPED"] = "STOPPED";
    SqlEngineStatus["SQL_ENGINE_STATUS_STARTING"] = "STARTING";
    SqlEngineStatus["SQL_ENGINE_STATUS_STARTED"] = "STARTED";
    SqlEngineStatus["SQL_ENGINE_STATUS_STOPPING"] = "STOPPING";
    SqlEngineStatus["SQL_ENGINE_STATUS_DELETING"] = "DELETING";
})(SqlEngineStatus || (SqlEngineStatus = {}));
